import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Filtros } from '../../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../../../shared/excel-service/export-excel.service';
import { Parametro } from '../../../../../shared/service-base/parametro';
import { AnaliseVendaBi01Service } from '../../bi01-analise-venda/analise-venda-bi01-service/analise-venda-bi01.service';
import { AnaliseMargemBi02Service } from '../../bi02-analise-margem/analise-margem-bi02-service/analise-margem-bi02.service';
import { AnaliseEstoqueBi04Service } from '../../bi04-analise-estoque/analise-estoque-bi04-service/analise-estoque-bi04.service';
import { AnaliseHoraBi05Service } from '../../bi05-analise-hora/analise-hora-bi05-service/analise-hora-bi05.service';
import { BiRelatorioAnaliseService } from '../bi-relatorio-analise.service';
import { AnalisePassagemBi03Service } from './../../bi03-analise-passagem/analise-passagem-bi03.service';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { FiltroService } from '../../../../../shared/filtro/filtro.service';
import { ServiceAppService } from '../../../../../security/service-app.service';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-bi-relatorio-analise-lista',
  templateUrl: './bi-relatorio-analise-lista.component.html',
  styleUrls: ['./bi-relatorio-analise-lista.component.css'],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ]
})
export class RelatorioAnaliseGeralListaComponent extends ListaBase implements OnInit {
  dados_bi01: any;
  dados_bi02: any;
  dados_bi03: any;
  dados_bi04: any;
  dados_bi05: any;
  exibirAnaliseVenda: boolean = false;
  exibirAnaliseMargem: boolean = false;
  exibirAnalisePassagem: boolean = false;
  exibirAnaliseEstoque: boolean = false;
  exibirAnaliseHora: boolean = false;
  anoFiltro: string = '';
  mesInicial: string = '';
  mesFinal: string = '';
  dealer: string = '';
  mercado: string = '';
  regiao: string = '';
  grupoEconomico: string = '';
  definirAno: boolean = false;
  private baseUrlService: string;
  isLoading = false;
  exibirDialogo: boolean = false;
  mercados: any[] = [];
  gruposEconomicos: any[] = [];
  regioes: any[] = [];
  dealers: any[] = [];
  marcas: any;
  exportarExcels: boolean = true;
  filtro = {
    dataInicial: new Date(new Date().getFullYear(), 0, 1),
    dataFinal: new Date(new Date().getFullYear() + 1, 0, 1)
  };


  filtrosPassagem = {
    ano: '',
    mes_inicial: '',
    mes_final: '',
    mercado: '',
    grupo_economico: '',
    regiao: '',
    dealer: ''
  }

  carregando = false;

  constructor(
    public httpClient: HttpClient,
    private serviceBi01: AnaliseVendaBi01Service,
    private serviceBi02: AnaliseMargemBi02Service,
    private serviceBi03: AnalisePassagemBi03Service,
    private serviceBi04: AnaliseEstoqueBi04Service,
    private serviceBi05: AnaliseHoraBi05Service,
    private biRelatorioService: BiRelatorioAnaliseService,
    toastr: ToastrService,
    router: Router,
    private exportExcel: ExportExcelService,
    private servico: FiltroService,
    private serviceMarca: ServiceAppService,
    private messageService: MessageService
  ) {
    super(serviceBi01, toastr, router);
    this.nomeModulo = 'bi-relatorio-analise';
    this.baseUrlService = environment.URL_API;
  }

  ngOnInit() {
    this.serviceMarca.getDados(`/admin/capturarMarca`).subscribe(res => {
      const marca = res.nome;
      if (marca.includes("VOLVO") || marca.includes("NBS")) {
        this.marcas = "Volvo";
      } else if (marca.includes("JLR")) {
        this.marcas = "JLR";
      }
    });

    this.buscar();
    this.preencherMercados();
    this.preencherGruposEconomicos();
    this.preencherRegioes();
    this.preencherDealers();
  }

  buscar() {
    this.filtrosEspecificos();
    this.filtrarMes();
    this.anoFiltro = this.filtros.ano;

    this.filtrosPassagem.ano = this.anoFiltro;
    this.filtrosPassagem.mes_inicial = this.mesInicial;
    this.filtrosPassagem.mes_final = this.mesFinal;
    this.filtrosPassagem.grupo_economico = this.grupoEconomico;
    this.filtrosPassagem.mercado = this.mercado;
    this.filtrosPassagem.dealer = this.dealer;

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.carregando = true;

    this.serviceBi01.buscar(objFiltro)
      .then(res => {

        this.dados_bi01 = res;

        this.carregando = false;
      });

    this.serviceBi02.buscar(objFiltro)
      .then(res => {

        this.dados_bi02 = res;

        this.carregando = false;
      });

    this.serviceBi03.getAllPaginate(this.filtrosPassagem.ano, this.filtrosPassagem.mes_inicial, this.filtrosPassagem.mes_final, this.filtrosPassagem.mercado, this.filtrosPassagem.grupo_economico, this.filtrosPassagem.regiao, this.filtrosPassagem.dealer)
      .subscribe(res => {
        this.dados_bi03 = res;

        this.carregando = false;
      });

    this.serviceBi04.buscar(objFiltro)
      .then(res => {

        this.dados_bi04 = res;

        this.carregando = false;
      });

    this.serviceBi05.buscar(objFiltro)
      .then(res => {

        this.dados_bi05 = res;

        this.carregando = false;
      });
  }

  protected filtrarMes() {
    if (parseFloat(this.filtros.mes_inicial) > parseFloat(this.filtros.mes_final)) {
      this.toastr.error('Filtro não permitido');
      this.filtros.mes_inicial = 1;
      this.filtros.mes_final = 12;
    } else {
      this.mesInicial = this.filtros.mes_inicial;
      this.mesFinal = this.filtros.mes_final;
    }
  }

  private filtrosEspecificos() {
    if (this.filtros.mercado != undefined) {
      this.mercado = this.filtros.mercado;
    }

    if (this.filtros.grupo_economico != undefined) {
      this.grupoEconomico = this.filtros.grupo_economico;
    }

    if (this.filtros.regiao != undefined) {
      this.regiao = this.filtros.regiao;
    }

    if (this.filtros.dealer != undefined) {
      this.dealer = this.filtros.dealer;
    }
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.ano
      || this.filtros.mes_inicial
      || this.filtros.mes_final;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportarExcel() {
    this.exportExcel.nomeModulo = this.nomeModulo;
    this.exportExcel.ExportTOExcelId("RPTGeralExcel");
  }

  async exportarListExcel() {
    let validacao = true;
    if (!this.marcas.includes("JLR")) {
        if (this.filtros.mes_inicial > this.filtros.mes_final) {
          this.exportarExcels = false;
          validacao = false;
          this.messageService.add({
            key: 'myKey1',
            severity: 'warn',
            summary: 'Aviso',
            life: 60000,
            detail: 'O Mês Inicial não pode ultrapassar o Mês Final. Por favor, verifique os parâmetros e ajuste para um período que o Mês Inicial seja menor que o Mês Final.'
          });
        }
    }

    if(validacao == true){
      this.isLoading = true;
      let url = `${this.baseUrlService}/rmpv/AnaliseGeralExport`;
      let url2 = '';
  
      if (this.marcas.includes("JLR")) {
        if (this.filtros.dealer) {
          url2 += `ID_DEALER=${this.filtros.dealer.id}`;
        }
      } else {
        if (this.filtros.dealer) {
          url2 += `ID_DEALER=${this.filtros.dealer}`;
        }
      }
  
      if (this.filtros.ano && this.filtros.ano.length > 0) {
        url2 += (url2 !== '') ? `&ANO=${this.filtros.ano}` : `ANO=${this.filtros.ano}`;
      }
      if (this.filtros.mes_inicial != null) {
        url2 += (url2 !== '') ? `&MES_INICIAL=${this.filtros.mes_inicial}` : `MES_INICIAL=${this.filtros.mes_inicial}`;
      }
      if (this.filtros.mes_final != null) {
        url2 += (url2 !== '') ? `&MES_FINAL=${this.filtros.mes_final}` : `MES_FINAL=${this.filtros.mes_final}`;
      }
      if (this.filtros.mercado && this.filtros.mercado.length > 0) {
        url2 += (url2 !== '') ? `&ID_MERCADO=${this.filtros.mercado}` : `ID_MERCADO=${this.filtros.mercado}`;
      }
      if (this.filtros.grupo_economico && this.filtros.grupo_economico.length > 0) {
        url2 += (url2 !== '') ? `&GRUPO_ECONOMICO=${this.filtros.grupo_economico}` : `GRUPO_ECONOMICO=${this.filtros.grupo_economico}`;
      }
      if (this.filtros.regiao && this.filtros.regiao.length > 0) {
        url2 += (url2 !== '') ? `&ID_REGIAO=${this.filtros.regiao}` : `ID_REGIAO=${this.filtros.regiao}`;
      }
      if (this.marcas.includes("JLR")) {
        url2 += (url2 !== '') ? `&DATA_INICIAL=${this.filtro.dataInicial}` : `DATA_INICIAL=${this.filtro.dataInicial}`;
        url2 += (url2 !== '') ? `&DATA_FINAL=${this.filtro.dataFinal}` : `DATA_FINAL=${this.filtro.dataFinal}`;
      }
  
      if (url2 !== '') {
        url += `?${url2}`;
      }
  
      try {
        const response = await this.httpClient.get(url, { responseType: 'blob' }).toPromise();
        const fileUrl = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'AnaliseGeralExport.xls');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(fileUrl);
  
      } catch (error) {
        console.error('Erro na requisição:', error);
      } finally {
        this.isLoading = false;
      }
    }
    
  }

  mostrarDialogo() {
    this.exibirDialogo = true;
  }

  fecharDialogo() {
    this.exibirDialogo = false;
  }

  aplicarFiltros() {
    if (this.marcas.includes("JLR")) {
    this.validacaoPeriodoData(this.filtro.dataInicial, this.filtro.dataFinal);
    }

    if (this.exportarExcels == true) {
      this.fecharDialogo();
      this.messageService.clear();
      this.exportarListExcel();
    }
    this.exportarExcels = true;
  }

  validacaoPeriodoData(dataInicial, dataFinal) {
    let ano1 = dataInicial.getFullYear();
    let mes1 = dataInicial.getMonth();
    let ano2 = dataFinal.getFullYear();
    let mes2 = dataFinal.getMonth();
    let totalMeses = (ano2 - ano1) * 12 + (mes2 - mes1);

    if (ano1 == ano2) {
      if (mes1 > mes2) {
        this.exportarExcels = false;
        this.messageService.add({
          key: 'myKey1',
          severity: 'warn',
          summary: 'Aviso',
          life: 60000,
          detail: 'O Mês Inicial não pode ultrapassar o Mês Final. Por favor, verifique os parâmetros e ajuste para um período que o Mês Inicial seja menor que o Mês Final.'
        });
      }
    }
      if (totalMeses > 11) {
        this.exportarExcels = false;
        this.messageService.add({
          key: 'myKey1',
          severity: 'warn',
          summary: 'Aviso',
          life: 60000,
          detail: 'O período informado ultrapassa um ano. Por favor, verifique os parâmetros e ajuste para um período de apenas um ano.'
        });
      }
  }
  preencherMercados() {
    this.servico.buscar('mercado')
      .then(r => { this.mercados = r.filtros; });
  }

  preencherGruposEconomicos() {
    this.servico.buscar('grupo_economico')
      .then(r => {
        this.gruposEconomicos = r.filtros;
      });
  }

  preencherRegioes() {
    this.servico.buscar('regiao')
      .then(r => { this.regioes = r.filtros; });
  }

  preencherDealers() {

    if (this.gruposEconomicos.length > 0) {

      this.servico.buscar('dealerGrupo/'.concat(this.gruposEconomicos[0].id))
        .then(r => { this.dealers = r.filtros; });

    } else {

      this.servico.buscar('dealer')
        .then(r => { this.dealers = r.filtros; });
    }
  }
}
